module.exports = __webpack_public_path__ + "static/media/4pic.79578ec0.png";